import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Card from './Card.js';
import Image from './Image.js';

class App extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      nasa: [],
    };

    // this.googleTranslateElementInit = this.googleTranslateElementInit.bind(this);
  }

  componentDidMount() {
    const url = `https://api.nasa.gov/planetary/apod?api_key=Sb9QfHPYeEMuEJFggku50FCo5rmfsnqKzLB1941m`;
    const options = {
      method: 'get',
    }

    fetch(url, options)
    .then(res => res.json())
    .then(data => { 
      this.setState({ 
        nasa: data 
      });
      
      console.log(data);
    })
    .catch(error => console.log('ERRO: ' + error))
  }

  // googleTranslateElementInit() {
  //   new google.translate.TranslateElement({
  //     pageLanguage: 'en', 
  //     layout: google.translate.TranslateElement.InlineLayout.SIMPLE
  //   }, 
  //     'google_translate_element'
  //   );
  // }

  render() {
    const { nasa } = this.state;

    return (
      <div className='App container-fluid'>
        <div className='row'>

          <header className='App-header col-3'>
            <div className='top-header'>
              <img src={ logo } className='App-logo' alt='logo' />
              <h1 className='special-text'>Major Tom</h1>
              <h4 className='special-text'>Incríveis imagens do universo!</h4>
              <h6 className='font-weight-light'>Uma imagem diferente por dia</h6>
            </div>
            <div className='bottom-header'>
              <a href='https://www.youtube.com/watch?v=iYYRH4apXDo' target="_blank"><p>♫ Ground Control to Major Tom, Ground Control to Major Tom... ♫</p></a>
            </div>
          </header>

          <section className='col-9'>
            <div id="google_translate_element">{ this.googleTranslateElementInit }</div>
            <Card data={ nasa } />
            <Image data={ nasa } /> 
          </section>

        </div>
      </div>
    );
  }
}

export default App;